import ability from "../../casl/Can";
import {RolePolicyActionEnum} from "../../commons/enums/role-policy-action.enum";
import {NotFound} from "../../commons/components";
import {useAuthRedirect} from "../../hooks/useAuthRedirect";
import {Subjects} from "../../casl/AbilityContext";

export default function AuthGuardWrapper({children,subject}: { children: React.ReactNode,subject:Subjects }) {
  useAuthRedirect();
    const canReadCompetition = ability.can(RolePolicyActionEnum.READ, subject);
    if (!canReadCompetition) {
        return <NotFound/>;
    }
    return <>{children}</>;
}